import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, User } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  city: 'Madrid, España',
  age: 34,
  image: 'https://i.pravatar.cc/150?img=11'
}, {
  name: 'Laura G.',
  city: 'Bogotá, Colombia',
  age: 28,
  image: 'https://i.pravatar.cc/150?img=5'
}, {
  name: 'Miguel A.',
  city: 'CDMX, México',
  age: 41,
  image: 'https://i.pravatar.cc/150?img=8'
}, {
  name: 'Sofía R.',
  city: 'Buenos Aires, Arg',
  age: 31,
  image: 'https://i.pravatar.cc/150?img=9'
}, {
  name: 'Javier T.',
  city: 'Santiago, Chile',
  age: 37,
  image: 'https://i.pravatar.cc/150?img=12'
}];
export function PurchaseNotification() {
  const [currentPurchase, setCurrentPurchase] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      setCurrentPurchase(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showNotification, 3000);
    // Loop
    const interval = setInterval(() => {
      showNotification();
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-288">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm w-[calc(100%-3rem)] sm:w-auto" data-id="element-289">
          <div className="relative" data-id="element-290">
            <img src={purchases[currentPurchase].image} alt={purchases[currentPurchase].name} loading="lazy" decoding="async" width={56} height={56} className="w-14 h-14 rounded-full object-cover border-2 border-green-500" data-id="element-291" />
            <div className="absolute -bottom-1 -right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-white" data-id="element-292"></div>
          </div>
          <div className="flex-1" data-id="element-293">
            <p className="text-sm text-gray-500 mb-0.5" data-id="element-294">
              Alguien acaba de comprar
            </p>
            <p className="font-bold text-gray-900 leading-tight" data-id="element-295">
              {purchases[currentPurchase].name}{' '}
              <span className="text-gray-400 font-normal text-sm" data-id="element-296">
                ({purchases[currentPurchase].age})
              </span>
            </p>
            <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-297">
              <MapPin className="w-3 h-3 mr-1" data-id="element-298" />
              {purchases[currentPurchase].city}
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}